import { Component, OnInit } from '@angular/core';
import { AmbitService } from '../ambit.service';
import * as firebase from 'firebase';
import { Router } from '@angular/router';

@Component({
  selector: 'app-shops',
  templateUrl: './shops.component.html',
  styleUrls: ['./shops.component.css']
})
export class ShopsComponent implements OnInit {

  public cityList:any = [];
  public allStopList:any = [];
  public stopList:any = [];
  public cityBlocked: boolean = false ;
  public mapCity:any ;
  public selectCity:any ;
  public loading:boolean = false;
  public stopCheckedList:any = [];
  public submitted: boolean = false ;
  public selectAll: boolean = false ;
  public stopModel:any = {
    stopName:'',
    stopAddress: '',
    cityID:'',
    latitude:'',
    longitude:'',
  };
  public filterCity:any = 'All';
  public searchList:any = ['name'];
  public sortColumn:any = 'name';
  public sortType:boolean = false ;

  public userSettings: any = {
    noOfRecentSearchSave: 3,
    inputPlaceholderText: 'Enter Club Address...'
  };

  constructor(public service:AmbitService,
    public router: Router) {
    if(this.service.adminUser.userAccess.stops =='None') {
      this.router.navigate(['/home']);
    }
   }

  ngOnInit() {
    this.getStopsData();
    }

    getStopsData() {
      var self = this;
      firebase.database().ref().child('Cities')
      .once('value', function (snapshot) {
        self.cityList = [];
        var data = snapshot.val();
        if (data) {
          for(var key in data) {
            data[key].cityID = key ;

            self.cityList.push(data[key]);
          }
          self.stopModel.cityID = self.cityList[0].cityID;
          self.selectCity = self.cityList[0].name;
          if(self.cityList[0].active) {
            self.cityBlocked = false ;
          } else {
            self.cityBlocked = true ;
          }
          //self.filterCity = self.cityList[0].cityID;
        }
      });

      firebase.database().ref().child('Stops')
      .once('value', function (snapshot) {
        self.allStopList = [];
        var data = snapshot.val();
        if (data) {
          for(var key in data) {
            data[key].stopID = key ;
           // data[key].name = data[key].name.toUpperCase();
            self.allStopList.push(data[key]);
          }
    
          if(self.service.searchedCity){
            self.filterCity = self.service.searchedCity ;
          }
          
          if(self.filterCity=='All') {
            self.stopList = self.allStopList ;
          } else {
            self.onChangeCity();
          }
        }
      });
    }

    getCityName(cityID) {
    
      var data = this.cityList.find(ob => ob['cityID'] === cityID );
      if(data) {
        return data.name ;
      } else {
        return '';
      }
    }

    onChangeCity() {
      this.stopList = [];
      if(this.filterCity=='All') {
        this.stopList = this.allStopList ;
      } else {
        for(var i=0; i<this.allStopList.length; i++ ) {
          if(this.filterCity == this.allStopList[i].cityID) {
            this.stopList.push(this.allStopList[i]);
          }
        }
      }
    }

    onSelectStop(stopID, isChecked: boolean) {
      
      if(stopID=='All' && !isChecked) {
        this.selectAll = false ; 
        this.stopCheckedList = [] ;
      } else if(stopID=='All' && isChecked) {
        this.selectAll = true ; 
        this.stopCheckedList = [] ;
        for(var i=0; i<this.stopList.length; i++) {
          this.stopCheckedList.push( this.stopList[i].stopID);
        }
      } else {
        if (isChecked) {
          this.stopCheckedList.push(stopID);
          if(this.stopCheckedList.length == this.stopList.length) {
            this.selectAll = true;
           }
         } else {
           this.stopCheckedList.splice(this.stopCheckedList.indexOf(stopID),1);
           if(!this.stopCheckedList.length || this.stopCheckedList.length != this.stopList.length) {
            this.selectAll = false;
           }
           
         } 
      }

      
    }

    checkActiveCity(cityID) {
      var data = this.cityList.find(ob => ob['cityID'] === cityID );
      if(data && data.active ) {
        this.cityBlocked = false ;
      } else {
        this.cityBlocked = true ;
      }
      if(data){
        this.selectCity = data.name ;
      }
    }

    toggleSortValue(val) {
      if(this.sortColumn==val){
        this.sortType = !this.sortType ;
      } else {
        this.sortColumn = val;
      }
    }

    emptyVariAble(check, stopData) {

      this.mapCity = '';
      if(check=='add') {
      this.stopModel = {
        stopName:'',
        stopAddress: '',
        cityID:this.cityList[0].cityID,
        latitude:'',
        longitude:'',
      };
      this.userSettings = {
        inputString: ''
      };
    } else if (check=='update') {
      
      this.stopModel.stopName=stopData.name; 
      this.stopModel.cityID=stopData.cityID
      if(stopData.address){
      this.stopModel.stopAddress=stopData.address; 
      this.userSettings = {
        inputString: stopData.address 
      };
      } else {
        this.stopModel.stopAddress = stopData.name;
        this.userSettings = {
          inputString: stopData.name 
        };
      } if(stopData.latitude) {
        this.stopModel.latitude = stopData.latitude ;
      } if(stopData.longitude) {
        this.stopModel.longitude = stopData.longitude ;
      }
    }
    }


    addNewStop() {
      var self=this;
      self.loading = true;
        var formData = {
          name: self.stopModel.stopName,
          address: self.stopModel.stopAddress,
          cityID: self.stopModel.cityID,
          latitude: self.stopModel.latitude,
          longitude: self.stopModel.longitude,
          active: true,
          timeStamp: firebase.database.ServerValue.TIMESTAMP,
        };

        var stopID = firebase.database().ref().child('Stops/').push().key;
  
        var updates = {};
        updates['/Stops/' + "/" + stopID] = formData;
        firebase.database().ref().update(updates).then(() => {
       // firebase.database().ref('Stops').push(formData).then((result) => {
         // self.stopList.unshift(formData);
         formData['stopID'] = stopID ;
          self.allStopList.unshift(formData);
          self.onChangeCity();
          document.getElementById('addStopMd').click();
          self.loading = false;
        }).catch((err) => {
          self.loading = false;
          alert(err);
        });
      
    }
  

    updateStop(check, key) {

      var self = this;
      self.loading = true;
      var data = self.stopList.find(ob => ob['stopID'] === key)
      var updateData: any = {};
      updateData['Stops/' + key] = data;
      if (check == 'stop') {
        updateData['Stops/' + key].name = self.stopModel.stopName;
        updateData['Stops/' + key].address = self.stopModel.stopAddress;
        updateData['Stops/' + key].cityID = self.stopModel.cityID;
        updateData['Stops/' + key].longitude = self.stopModel.longitude;
        updateData['Stops/' + key].latitude = self.stopModel.latitude;
      } else if (check == 'status') {
        if (data.active) {
          updateData['Stops/' + key].active = false;
        } else {
          updateData['Stops/' + key].active = true;
        }
  
      }
  
      firebase.database().ref().update(updateData).then(() => {
        self.getStopsData();
        if (check == 'stop') {
          document.getElementById('addStopMd').click();
        } else if (check == 'status') {
          document.getElementById('closeStatusMd').click();
        }
        self.loading = false;
      });
  
    }

    removeStop() {
      var self = this;
      var count=0;
      self.loading = true;
      for( var i=0; i<self.stopCheckedList.length ; i++) {
       
        firebase.database().ref('Stops/' + self.stopCheckedList[i]).remove().then(() => {

          var index1 = self.allStopList.findIndex(x => x.stopID === self.stopCheckedList[count]);
          count++;
          self.allStopList.splice(index1,1);
          if(count==self.stopCheckedList.length) {
            self.stopCheckedList = [] ;
            self.selectAll = false ;
            self.onChangeCity();
            document.getElementById('delStopMd').click();
          }
          self.loading = false;
        }).catch((err) => {
          self.loading = false;
          alert(err);
        });
      }
     
    }
  
    autoCompleteCallback(data: any): any {
      var self = this;
      self.checkActiveCity(self.stopModel.cityID)
      var tempArray = data.data.address_components;
      for (var i = 0; i < tempArray.length; i++) {
        var typesArray = tempArray[i].types;
        for (var j = 0; j < typesArray.length + 1; j++) {
           if (typesArray[j] == "locality") {
            self.mapCity = tempArray[i].long_name;
            break;
          } 
        }
      }
      self.stopModel.latitude = data.data.geometry.location.lat ;
      self.stopModel.longitude = data.data.geometry.location.lng ;
      self.stopModel.stopAddress = data.data.formatted_address ;
      
    
    }

  }